export const separateDuplicates = (items: string[], inventoryListSet: Set<string>) => {
  const duplicates: string[] = [];
  const nonDuplicates: string[] = [];

  for (const item of items) {
    if (inventoryListSet.has(item)) {
      duplicates.push(item);
    } else {
      nonDuplicates.push(item);
    }
  }

  return { duplicates, nonDuplicates };
};
